// eslint-disable-next-line import/prefer-default-export
export const AGENDA_SELECT_DATE = 'AGENDA_SELECT_DATE';
